import Api from "../../axios";

export default async function apiAttendanceApprovalCount() {
  return await Api.get(`attendance_approval_count`);
}
